import Base from './components/cells/Base';
import Digit from './components/cells/Digit';

export default function NumberCell() {}

NumberCell.prototype.init = function (params) {
    this.eGui = Base(Digit(params), params);
    return;
};

NumberCell.prototype.getGui = function () {
    return this.eGui;
};
